import React from 'react';
import {Input} from "antd";
import {propsEmpty} from "../../../util/varibles/constants";
import {IPropsElement} from "../../../pages/ChecklistPage/PopupEdit/constants";
import {callEventChecklist, getChecklist, useChecklist} from "../ChecklistContext";


const LongTextElement: React.FC<IPropsElement> = (props) => {
    const {placeHolder, numberOfRows} = props.properties;
    const {index} = props;
    const [value] = useChecklist(state => state.result[index]);
    const {onResultChange} = callEventChecklist();
    const {disabled} = getChecklist()();

    return <Input.TextArea
        {...{...propsEmpty, placeholder: placeHolder || '', rows: numberOfRows || 1}}
        disabled={disabled}
        value={value}
        onChange={({target}) => onResultChange({[index]: target.value})}
    />
};

export default LongTextElement;
